import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SubNavbarComponent } from './components/sub-navbar/sub-navbar.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
  declarations: [
    NavbarComponent,
    SubNavbarComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
  ],
  exports: [
    NavbarComponent,
    SubNavbarComponent,
    FooterComponent
  ]
})
export class SharedModule { }
